import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { auth, signInWithEmailAndPassword } from 'config/firebase';
import SignInVector from 'assets/vectors/SignIn.svg';
import TextInput from 'components/TextInput';
import Button from 'components/Button';
import SignInWithGoogle from 'components/SignInWithGoogle';
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
import { ENABLE_STUDENT_SIGNUP } from 'global/constants';
import { setAlert } from 'store/error';
import './index.css';

function SignIn() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const dispatch = useAppDispatch();
    const { organization } = useAppSelector(state => state.organization);
    const { state } = useLocation() as {
        state?: { referrer?: string; }
    };

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        signInWithEmailAndPassword(auth, email, password)
            .catch(error => {
                dispatch(setAlert({
                    response: {
                        data: {
                            message: error.message
                        }
                    }
                }));
            });
    }

    return (
        <div className='layout'>
             <Helmet>
                <title>
                    Sign in - {organization.name}
                </title>
            </Helmet>
            <form className='signIn' onSubmit={handleSubmit}>
                <img
                    className='signIn__vector'
                    src={SignInVector}
                    alt='Sign In'
                />
                <h1 className='signIn__header'>
                    Sign in to your account
                </h1>
                <TextInput 
                    name='email'
                    label='email address'
                    onChange={(event) => setEmail(event.target.value)}
                    required
                    type='email'
                    value={email}
                />
                <TextInput
                    name='password'
                    label='password'
                    onChange={(event) => setPassword(event.target.value)}
                    required
                    type='password'
                    value={password}
                />
                <Button 
                    className='signIn__button'
                    fullWidth
                    secondary={!email || !password}
                    type='submit'
                >
                    SIGN IN
                </Button>
                {/* <SignInWithGoogle className="signIn__googleButton" /> */}
                {ENABLE_STUDENT_SIGNUP.includes(organization.alias) && 
                    <div className='signIn__action'>
                        <p className='signIn__actionText'>
                            Don't have an account?
                        </p>
                        <Link
                            to='/sign-up'
                            className='signIn__actionLink'
                            state={state?.referrer 
                                ? { referrer: state.referrer }
                                : null
                            }
                        >
                            Create one here
                        </Link>
                    </div>
                }
                {/* <div className='signIn__action'>
                    <p className='signIn__actionText'>
                        Forgot password?
                    </p>
                    <Link to='/password-reset' className='signIn__actionLink'>
                        Click here to reset
                    </Link>
                </div> */}
            </form>
        </div>
    );
}

export default SignIn;